module.exports = __webpack_public_path__ + "src/assets/models/micropipette/trash_can.fbx";